import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { fetchDealById } from 'submission/lib/deal-api'
import { ProjectBreadcrumbs } from 'components/Projects/project-breadcrumbs'
import { Navbar } from 'components/navbar'
import { Footer } from 'components/footer'
import VolumeSourcePanel from './VolumeSourcePanel'
import CompensationPanel from './CompensationPanel'

const PartnerProgram: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [deal, setDeal] = useState<any | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!projectId) return
    let cancelled = false
    fetchDealById(projectId)
      .then((d) => {
        if (!cancelled) setDeal(d)
      })
      .catch((e: Error) => {
        if (!cancelled) setError(e.message)
      })
    return () => {
      cancelled = true
    }
  }, [projectId])

  if (!projectId) return <div className="p-8">Missing project id.</div>

  return (
    <div className="flex flex-col min-h-screen bg-neutral-white font-sans text-neutral-900">
      <Navbar />
      <main className="flex-1 mx-auto w-full max-w-6xl px-4 md:px-8 py-6 space-y-6">
        <ProjectBreadcrumbs
          projectTitle={deal?.metadata?.overview?.projectName}
        />
        <div>
          <h1 className="text-2xl font-semibold">
            Partner Program ·{' '}
            {deal?.metadata?.overview?.projectName ?? `Deal ${projectId}`}
          </h1>
          <Link
            to={`/deals/${projectId}`}
            className="text-sm text-brand-primary"
          >
            Back to deal
          </Link>
        </div>
        {error && (
          <div className="text-sm text-red-600">
            Failed to load deal: {error}
          </div>
        )}
        <VolumeSourcePanel dealId={projectId} />
        <CompensationPanel dealId={projectId} />
      </main>
      <Footer />
    </div>
  )
}

export default PartnerProgram
